// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2816":"482226ef","3202":"482226ef","3639":"482226ef","5599":"482226ef","5683":"482226ef","9008":"37d3fc1e"}[chunkId] + ".chunk.css";
};